/* =============================================================
 *  INFINAGON RECORDINGS — A/B AUDIO TRACKS CONFIGURATION
 * =============================================================
 *
 *  👉 THIS IS THE ONLY FILE YOU NEED TO EDIT TO ADD / REPLACE
 *     BEFORE & AFTER AUDIO EXAMPLES IN THE "LISTEN" PLAYER.
 *
 *  HOW TO ADD A NEW TRACK
 *  ----------------------
 *  1. Drop your two audio files into:
 *        /app/frontend/public/audio/<file>.mp3
 *     (they will be reachable at  /audio/<file>.mp3 )
 *     Or host them anywhere publicly accessible (S3, CDN, etc.).
 *  2. Copy the TEMPLATE block below, paste it just after the
 *     template (still inside the `abTracks` array), uncomment
 *     it (remove the leading "// " on each line), then fill in
 *     the values.
 *  3. Save the file — the player picks it up automatically.
 *
 *  NOTES
 *  • `before` and `after` MUST be same-length recordings
 *    for the instant A/B toggle to line up naturally.
 *  • Supported formats: .mp3, .wav, .ogg, .m4a
 *  • Comments here are invisible to website visitors — they only
 *    show up in this source file.
 * ============================================================= */

export const abTracks = [

  // ──────────────── A/B TRACK TEMPLATE  ▼ ────────────────────
  // {
  //   id: "unique-slug-here",         // kebab-case unique id
  //   title: "Track Title",           // display name
  //   artist: "Artist Name",          // display name
  //   category: "Mix + Master",       // Mix | Master | Production | Recording
  //   year: "2025",                   // string year
  //   notes: "Short 1-line note shown under the title.",
  //   before: "/audio/your-before.mp3", // raw / unprocessed audio
  //   after:  "/audio/your-after.mp3",  // mixed / mastered audio
  // },
  // ──────────────── A/B TRACK TEMPLATE  ▲ ────────────────────

  {
    id: "mesa-petitabisme",
    title: "Petit Abisme",
    artist: "Masé Jara",
    category: "Mix + Master",
    year: "2023",
    notes: "Mixing & Mastering Engineer.",
    before: "/audio/PetitAbisme_Before.mp3",
    after: "/audio/PetitAbisme_After.mp3",
  },
  {
    id: "grns-liberation",
    title: "Liberation",
    artist: "grns",
    category: "Recording + Mix + Master",
    year: "2022",
    notes: "Tracking, Mixing & Mastering Engineer.",
    before: "/audio/Liberation1_Before.mp3",
    after: "/audio/Liberation1_After.mp3",
  },
  {
    id: "dubbel-waardanook",
    title: "Waar Dan Ook",
    artist: "DuBBel",
    category: "Mix + Master",
    year: "2022",
    notes: "Mixing & Mastering Engineer.",
    before: "/audio/WaarDanOok_Before.mp3",
    after: "/audio/WaarDanOok_After.mp3",
  },
  {
    id: "amanda-whatupayfor",
    title: "Get What You Pay For",
    artist: "Amanda Mabro",
    category: "Mix + Master",
    year: "2023",
    notes: "Mixing & Mastering Engineer.",
    before: "/audio/WhatUpayFor_Before.mp3",
    after: "/audio/WhatUpayFor_After.mp3",
  },
  {
    id: "tony-boytraveled",
    title: "Boy Traveled",
    artist: "Tony Favor",
    category: "Recording + Mix + Master",
    year: "2021",
    notes: "Tracking, Mixing & Mastering Engineer.",
    before: "/audio/BoyTraveled_Before.mp3",
    after: "/audio/BoyTraveled_After.mp3",
  },

];

export default abTracks;
